/**
 * External dependencies.
 */
import React, { useEffect, useRef } from "react";
import Image from "next/image";
import Slider from "react-slick";

/**
 * Internal dependencies.
 */
import { getStrapiMediaArr } from "utils";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface ProductSliderProp {
  data: any;
  activeIndex: number;
}

const ProductSlider: React.FC<ProductSliderProp> = ({ data }) => {
  const sliderRef: any = useRef();
  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: (i: number) => (
      <a>
        {data && data[i] && (
          <Image
            alt=""
            src={getStrapiMediaArr(data[i])}
            width={60}
            height={66}
          />
        )}
      </a>
    ),
  };

  useEffect(() => {
    sliderRef.current?.slickGoTo(0, true);
  }, [data]);

  return (
    <div className="slider-holder">
      <div className="slider-holder__slides">
        <Slider {...settings} ref={(slider) => (sliderRef.current = slider)}>
          {data?.map((image: any, index: number) => (
            <div key={index}>
              <Image
                alt=""
                src={getStrapiMediaArr(image)}
                width={image.attributes.width}
                height={image.attributes.height}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ProductSlider;
